import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons'
import type { Partner } from '@entities/partner'
import { usePartners } from '@entities/partner/model/hooks/use-partners'
import useMobileView from '@shared/hooks/isMobile'
import { dateToString } from '@shared/lib/dateToString/dateToString'
import type { TableProps } from 'antd'
import { Button, Card, Dropdown, Flex, Popconfirm, Space, Table, theme, Typography } from 'antd'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

const { Title } = Typography

export const PartnersPage = () => {
    const isMobile = useMobileView()
    const {
        token: { colorLink, colorWhite }
    } = theme.useToken()

    const {
        partners,
        isPartnersLoading,
        actions: { deletePartner }
    } = usePartners()

    const navigate = useNavigate()

    const columns: TableProps<Partner>['columns'] = useMemo(
        () => [
            {
                title: 'Партнер',
                dataIndex: 'name',
                key: 'name',
                render: (_, record) => (record.linkedPartner ? record.linkedPartner.name : record.name)
            },
            {
                title: 'Username',
                dataIndex: 'tgUsername',
                key: 'tgUsername',
                render: (_, record) => (record.linkedPartner ? record.linkedPartner.tgUsername : record.tgUsername)
            },
            {
                title: 'Телефон',
                dataIndex: 'phone',
                key: 'phone',
                render: (_, record) => (record.linkedPartner ? record.linkedPartner.phone : record.phone)
            },
            {
                title: 'E-mail',
                dataIndex: 'email',
                key: 'email',
                render: (_, record) => (record.linkedPartner ? record.linkedPartner.email : record.email)
            },
            {
                title: 'Закупил',
                dataIndex: 'purchasedCount',
                key: 'purchasedCount',
                render: (_, record) => record.statistics?.purchasedCount
            },
            {
                title: 'Сумма закупов',
                dataIndex: 'purchasedAmount',
                key: 'purchasedAmount',
                render: (_, record) => record.statistics?.purchasedAmount
            },
            {
                title: 'Продал',
                dataIndex: 'soldCount',
                key: 'soldCount',
                render: (_, record) => record.statistics?.soldCount
            },
            {
                title: 'Сумма продаж',
                dataIndex: 'soldAmount',
                key: 'soldAmount',
                render: (_, record) => record.statistics?.soldAmount
            },
            {
                title: 'Добавлен',
                dataIndex: 'createdAt',
                key: 'createdAt',
                render: (_, record) => {
                    return dateToString(record.createdAt)
                }
            },
            {
                title: 'Действия',
                key: 'action',
                render: (_, record) => (
                    <Dropdown
                        trigger={['click']}
                        menu={{
                            items: [
                                {
                                    key: '1',
                                    label: (
                                        <Space style={{ color: colorLink, width: '100%' }}>
                                            <EditOutlined /> Редактировать
                                        </Space>
                                    ),
                                    onClick: () => navigate(`/advertising/partners/${record.id}`)
                                },
                                {
                                    key: '3',
                                    danger: true,
                                    label: (
                                        <Popconfirm
                                            title="Удалить партнера"
                                            description="Вы уверены что хотите удалить партнера?"
                                            onConfirm={() => deletePartner({ id: record.id })}
                                            okText="Удалить"
                                            cancelText="Отмена"
                                        >
                                            <Space style={{ width: '100%' }}>
                                                <DeleteOutlined /> Удалить
                                            </Space>
                                        </Popconfirm>
                                    )
                                }
                            ]
                        }}
                    >
                        <MoreOutlined />
                    </Dropdown>
                )
            }
        ],
        [colorLink, deletePartner, navigate]
    )

    if (isMobile) {
        return (
            <>
                <Card style={{ flex: 1, borderRadius: 0 }}>
                    <Title level={3} style={{ marginBottom: 24, marginTop: 150, textAlign: 'center' }}>
                        😅 Ой! Миниап пока не вырос.Загляните с десктопа — там всё уже работает как надо!
                    </Title>
                    {/*<Flex vertical gap={10}>*/}
                    {/*    {partners?.map((partner) => (*/}
                    {/*        <Card style={{ backgroundColor: colorWhite }}>*/}
                    {/*            <Flex gap={10}>*/}
                    {/*                <Avatar shape="circle" size={50} src={partner?.photoUrl} />*/}
                    {/*                <Flex vertical style={{ width: '83%' }}>*/}
                    {/*                    <Flex justify={'space-between'}>*/}
                    {/*                        <Title level={4} style={{ margin: 0, cursor: 'pointer' }}>*/}
                    {/*                            <Space>{partner?.name}</Space>*/}
                    {/*                        </Title>*/}
                    {/*                        <Dropdown*/}
                    {/*                            trigger={['click']}*/}
                    {/*                            placement="bottomRight"*/}
                    {/*                            menu={{*/}
                    {/*                                items: [*/}
                    {/*                                    {*/}
                    {/*                                        key: '1',*/}
                    {/*                                        label: (*/}
                    {/*                                            <Space style={{ color: colorLink }}>*/}
                    {/*                                                <EditOutlined /> Редактировать*/}
                    {/*                                            </Space>*/}
                    {/*                                        ),*/}
                    {/*                                        onClick: () =>*/}
                    {/*                                            navigate(`/advertising/partners/${partner.id}`)*/}
                    {/*                                    },*/}
                    {/*                                    {*/}
                    {/*                                        key: '2',*/}
                    {/*                                        danger: true,*/}
                    {/*                                        label: (*/}
                    {/*                                            <Popconfirm*/}
                    {/*                                                title="Удалить партнера"*/}
                    {/*                                                description="Вы уверены что хотите удалить партнера?"*/}
                    {/*                                                onConfirm={() => deletePartner({ id: partner.id })}*/}
                    {/*                                                okText="Удалить"*/}
                    {/*                                                cancelText="Отмена"*/}
                    {/*                                            >*/}
                    {/*                                                <Space style={{ width: '100%' }}>*/}
                    {/*                                                    <DeleteOutlined /> Удалить*/}
                    {/*                                                </Space>*/}
                    {/*                                            </Popconfirm>*/}
                    {/*                                        )*/}
                    {/*                                    }*/}
                    {/*                                ]*/}
                    {/*                            }}*/}
                    {/*                        >*/}
                    {/*                            <MoreOutlined />*/}
                    {/*                        </Dropdown>*/}
                    {/*                    </Flex>*/}
                    {/*                </Flex>*/}
                    {/*            </Flex>*/}
                    {/*        </Card>*/}
                    {/*    ))}*/}
                    {/*</Flex>*/}
                </Card>
            </>
        )
    }
    return (
        <Card>
            <Flex justify="space-between" align="center" style={{ marginBottom: '16px' }}>
                <Title level={3}>Партнеры</Title>
                <Button type="primary" onClick={() => navigate('new')}>
                    Добавить партнера
                </Button>
            </Flex>

            <Table<Partner>
                columns={columns}
                dataSource={partners}
                pagination={false}
                rowKey={'id'}
                loading={isPartnersLoading}
                scroll={{
                    y: 'calc(100vh - 380px)'
                }}
            />
        </Card>
    )
}
